import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for reversion reload.
 * @extends JetView
 */
export default class tableReversionReloadView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 100, // Column width
                    height: 25, // Column height
                    tooltip: _('Acción'), // Tooltip for the column
                    template: function (obj) {
                        // Template function for rendering cell content
                        if (obj.State == 'A') {
                            return "<span class='webix_icon wxi-close details'></span><span class='webix_icon wxi-close info'></span><span placeholder='Aprobar' class='webix_icon wxi-close approve'></span>";
                        } else {
                            return "<span class='webix_icon wxi-close details'></span><span class='webix_icon wxi-close info'></span>";
                        }
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'DateTimeCreation', // Creation date column
                    header: _('Fecha/Hora Creación'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Name', header: _('Nombres'), width: 150, sort: 'int' }, // Name column
                {
                    id: 'Lastname', // Lastname column
                    header: _('Apellidos'), // Localized header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Company', // Company column
                    header: _('Empresa'), // Localized header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Email', header: _('Email'), width: 250, sort: 'int' }, // Email column
                { id: 'Phone', header: _('Teléfono'), width: 100, sort: 'int' }, // Phone column
                {
                    id: 'Country', // Country column
                    header: _('País'), // Localized header
                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByCountry', // CSS class for styling
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Depto', // Department column
                    header: _('Provincia'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Address', // Address column
                    header: _('Dirección'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Skype', header: _('Skype'), width: 250, sort: 'int' }, // Skype column
                {
                    id: 'Observation', // Observation column
                    header: _('Observación'), // Localized header
                    width: 250, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'DateTimeLastModif', // Last modification date column
                    header: _('Fecha/Hora Ultima Modif'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'UserLastModification', // Last modification user column
                    header: _('Usuario Ultima Modif'), // Localized header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Handler for details button click
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('detailsManagementContact:id', [
                        item.Id, // Pass the item ID to the event
                    ]);
                    if (screen.width < 500 || screen.height < 500) {
                        // Check screen size for responsive design
                        $$('filterDetails').show(); // Show filter details if screen is small
                    }
                },
                info: function (euv, id) {
                    // Handler for info button click
                    this.$scope.app.callEvent('popupInfo:button', [[]]); // Trigger popup info event
                },
                approve: function (euv, id) {
                    // Handler for approve button click
                    var vvthis = this; // Preserve context
                    webix.confirm({
                        // Confirmation dialog
                        type: 'confirm-warning', // Dialog type
                        text: _('Advertencia!') + '<br/>' + _('Desea Terminar Gestión?'), // Confirmation message
                        ok: _('Terminar Gestión'), // OK button text
                        cancel: _('Salir'), // Cancel button text
                        callback: function (action) {
                            // Callback for confirmation action
                            if (action === true) {
                                // If confirmed
                                var item = vvthis.getItem(id); // Get the item
                                webix
                                    .ajax() // AJAX request to end management
                                    .headers({
                                        'Content-type': 'application/json', // Set content type
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'ManagementContact/EndManagement', // API endpoint
                                        '{ "Id":' + item.Id + '}', // Request body
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                // Error handler
                                                webix.message('Error! '); // Show error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                // Success handler
                                                var json = JSON.parse(text); // Parse response
                                                if (json.HasError) {
                                                    // Check for errors
                                                    webix.message({
                                                        title: '¡Error!', // Error title
                                                        type: 'alert-error', // Error type
                                                        text: _(
                                                            'Ocurrio un error...', // Error message
                                                        ),
                                                    });
                                                } else {
                                                    webix.message(
                                                        _(
                                                            'Gestión Terminada satisfactoriamente. ', // Success message
                                                        ),
                                                    );
                                                    item.State = 'I'; // Update item state
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            footer: false, // Disable footer
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'Management/GetManagementContact'; // API endpoint for management contacts
        var filter = ''; // Filter string
        var vthis = this; // Preserve context
        this.on(this.app, 'managementContact:filter', (filterData) => {
            // Event listener for filter updates
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                string1 = string1 + '&dateFrom=' + date; // Add date to filter string
                                string1 = string1 + '&dateTo=' + date; // Add date to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object filter entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        var popupInfo = webix.ui({
            // Create popup window for info
            view: 'window', // Window view
            id: 'infoWindow', // Window ID
            width: 500, // Window width
            height: 500, // Window height
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                // Window header
                view: 'toolbar', // Toolbar view
                cols: [
                    // Toolbar columns
                    { view: 'label', label: _('Información') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click handler for closing the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                // Window body
                view: 'scrollview', // Scrollable view
                scroll: 'xy', // Scroll in both directions
                body: {
                    // Inner body
                    view: 'form', // Form view
                    id: 'infoForm', // Form ID
                    elements: [
                        // Form elements
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'text', // Text input for ID
                                    labelPosition: 'top', // Label position
                                    label: _('Id'), // Localized label
                                    name: 'Id', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for creation date
                                    labelPosition: 'top', // Label position
                                    label: _('Fecha/Hora Creación'), // Localized label
                                    name: 'DateTimeCreation', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'text', // Text input for names
                                    labelPosition: 'top', // Label position
                                    label: _('Nombres'), // Localized label
                                    name: 'Name', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for lastnames
                                    labelPosition: 'top', // Label position
                                    label: _('Apellidos'), // Localized label
                                    name: 'Lastname', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'text', // Text input for company
                                    labelPosition: 'top', // Label position
                                    label: _('Empresa'), // Localized label
                                    name: 'Company', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for email
                                    labelPosition: 'top', // Label position
                                    label: _('Email'), // Localized label
                                    name: 'Email', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'text', // Text input for phone
                                    labelPosition: 'top', // Label position
                                    label: _('Teléfono'), // Localized label
                                    name: 'Phone', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for country
                                    labelPosition: 'top', // Label position
                                    label: _('País'), // Localized label
                                    name: 'Country', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'text', // Text input for department
                                    labelPosition: 'top', // Label position
                                    label: _('Provincia'), // Localized label
                                    name: 'Depto', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for address
                                    labelPosition: 'top', // Label position
                                    label: _('Dirección'), // Localized label
                                    name: 'Address', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'text', // Text input for Skype
                                    labelPosition: 'top', // Label position
                                    label: _('Skype'), // Localized label
                                    name: 'Skype', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Column layout
                                {
                                    view: 'textarea', // Textarea for observation
                                    labelPosition: 'top', // Label position
                                    label: _('Observación'), // Localized label
                                    name: 'Observation', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                    height: 150, // Height of the textarea
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'popupInfo:button', (filter) => {
            // Event listener for popup info button
            popupInfo.show(); // Show the popup window
            $$('infoForm').bind($$('datatable')); // Bind the form to the datatable
        });
    }
}

// FILE DOCUMENTED
